// extracted by mini-css-extract-plugin
export default {"page_d":"PaginationBox_page_d__JiXlW","page_l":"PaginationBox_page_l__6Fzpm","active":"PaginationBox_active__DZSyG"};